import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useStore } from 'stores';
import { Delete, PencilAlt } from 'assets/icons';
import InputWithButton from 'components/InputWithButton';
import Checkbox from './Checkbox';
import { deleteUserMarketProfile } from 'api/strategy';
import { formatStockNumber } from 'utils/stock';

function Strategy() {
  const { t } = useTranslation();
  const [isEdit, setIsEdit] = useState(false);
  const [checkedIdList, setCheckedIdList] = useState([]);
  const currentEmail = useStore((state) => state.currentEmail);
  const UserMarketProfile = useStore((state) => state.UserMarketProfile);
  const setUserMarketProfile = useStore((state) => state.setUserMarketProfile); /** 自選策略清單 */

  function handleCheckboxChange(id) {
    const targetIdx = checkedIdList.indexOf(id);
    const newList = [].concat(checkedIdList);
    if (targetIdx >= 0) {
      newList.splice(targetIdx, 1);
    } else {
      newList.push(id);
    }
    setCheckedIdList(newList);
  }

  async function handleDelete() {
    if (checkedIdList.length !== 0) {
      const res = await deleteUserMarketProfile(currentEmail, checkedIdList);
      if (res) {
        setUserMarketProfile(res);
      }
    }

    setIsEdit(false);
  }

  return (
    <div className="pb-4">
      <InputWithButton type="plus" />
      <div className="mx-2">
        {isEdit ? (
          <Delete
            className={classNames(' w-6 h-6', {
              'text-gray': checkedIdList.length === 0,
              'text-blue': checkedIdList.length !== 0,
            })}
            onClick={handleDelete}
          />
        ) : (
          <PencilAlt className="text-gray w-6 h-6" onClick={() => setIsEdit(true)} />
        )}
      </div>

      <div className="rounded-lg overflow-hidden m-2 my-4">
        {/* table head */}
        <div className="bg-gray text-white flex py-4 px-2">
          {isEdit && <div className="w-6 mr-2" />}
          <div className="flex-1">{t('Strategy.symbol')}</div>
          <div className="flex-2">{t('Strategy.name')}</div>
          <div className="flex-2">{t('Strategy.strategy')}</div>
          <div className="flex-1">{t('Strategy.price')}</div>
        </div>

        {/* table body */}
        {UserMarketProfile ? (
          UserMarketProfile.map((data, index) => {
            return (
              <div
                key={`table_row_${data.MarketProfileId}`}
                className={classNames('flex justify-between py-4 px-2', {
                  'bg-gray-light': index % 2,
                  'bg-white': (index + 1) % 2,
                })}
              >
                {isEdit && (
                  <Checkbox
                    checked={checkedIdList.indexOf(data.MarketProfileId) >= 0}
                    onChange={() => handleCheckboxChange(data.MarketProfileId)}
                  />
                )}
                {/* 代碼 */}
                <div className="flex-1">{formatStockNumber(data)}</div>
                {/* 股票策略 */}
                <div className="flex-2">{data.MarketName}</div>
                {/* 策略 */}
                <div className="flex-2">{data.StrategyProfileName}</div>
                {/* 股價 目前沒有..也沒有顏色 */}
                <div
                  className={classNames('flex-1', {
                    'text-red': data.color === 'red',
                    'text-green': data.color === 'green',
                  })}
                >
                  {data.price || '-'}
                </div>
              </div>
            );
          })
        ) : (
          <div> 暫無資料 </div>
        )}
      </div>
    </div>
  );
}

export default Strategy;
